import { render, staticRenderFns } from "./RedeBaseDeDados.vue?vue&type=template&id=178b7c82&"
import script from "./RedeBaseDeDados.vue?vue&type=script&lang=js&"
export * from "./RedeBaseDeDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports